export default "__VITE_ASSET__BXG$1Y9c__"